<div class="business-document-view-state" *ngIf="loading">Loading business document…</div>

<div class="business-document-view-state business-document-view-error" *ngIf="!loading && errorMessage">
  <p>{{ errorMessage }}</p>
  <button class="btn" type="button" (click)="close()">Back</button>
</div>

<div
  class="business-document-view-shell"
  [class.business-document-view-shell-embedded]="embedded"
  *ngIf="!loading && printable as view"
>
  <header class="business-document-view-toolbar d-print-none">
    <button class="btn" type="button" *ngIf="!embedded" (click)="close()"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-1">
                          <path d="M18 6l-12 12"></path>
                          <path d="M6 6l12 12"></path>
                        </svg> Close</button>
    <div class="btn-list ms-auto">
      <button class="btn" type="button" (click)="print()"><i class="ti ti-printer"></i> Print</button>
      <button class="btn btn-primary" type="button" (click)="download()">
        <i class="ti ti-download"></i> Download PDF
      </button>
    </div>
  </header>

  <main class="business-document-view-paper">
    <div class="business-document-view-heading">
      <div>
        <div class="business-document-view-kicker">{{ view.documentType }}</div>
        <h1>{{ view.documentNumber }} <app-information title="Business Document View" [page]="!embedded" class="d-print-none"><ng-template><p>Review the document number, details, lines and totals in a read-only printable layout.</p><p>Use Print for the browser print view or Download PDF for an exported copy. Return to the owning application for permitted editing and workflow actions; viewing or exporting this document does not post accounting or move stock.</p></ng-template></app-information></h1>
        <p>{{ view.title }}</p>
      </div>
      <div class="business-document-view-brand">East Coast Engineering</div>
    </div>

    <dl class="business-document-view-fields" *ngIf="view.fields?.length">
      <div *ngFor="let field of view.fields"><dt>{{ field.label }}</dt><dd>{{ field.value }}</dd></div>
    </dl>

    <table class="business-document-view-lines" *ngIf="view.table as table">
      <thead><tr><th *ngFor="let header of table.headers">{{ header }}</th></tr></thead>
      <tbody>
        <tr *ngFor="let row of table.rows"><td *ngFor="let value of row">{{ value }}</td></tr>
      </tbody>
    </table>

    <div class="business-document-view-totals" *ngIf="view.totals?.length">
      <div *ngFor="let total of view.totals"><span>{{ total.label }}</span><strong>{{ total.value }}</strong></div>
    </div>

    <section class="business-document-view-notes" *ngIf="view.notes">
      <h2>Notes</h2>
      <p>{{ view.notes }}</p>
    </section>
  </main>
</div>
